module.exports = __webpack_public_path__ + "img/b552e39.svg";